import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import "../BlogsView/BlogView.css";
import blog11 from "../../../../img/blog11.png";
import imgblogfirst from "../../../../img/blogfirst.png";
import demoimg from "../../../../img/demo.png";
import { Link } from "react-router-dom";

export default function BlogsView() {
  return (
    <>
      <Header />
      <section className="Blog_view">
        <div className="container">
          <h1>7 Common Myths About Hearing Aids</h1>
        </div>
      </section>
      <section className="Blog_text">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="blog_details">
                <div className="blog_img">
                  <div className="blog_list">
                    <p>JUNE 23, 2022</p>
                    <a href="#COMMENTS_text">7 COMMENTS</a>
                  </div>
                  <img src={blog11} className="img-fluid" />
                </div>
                <div className="blog_menu">
                  <h1 className="Blog_heding">
                    7 Common Myths About Hearing Aids
                  </h1>

                  <p>
                    <b>Hearing</b> Aids are sophisticated electronic devices
                    that a person with hearing loss can use to help them hear
                    better again. But the decision to purchase and use one is
                    often met with resistance because of misinformation. In this
                    blog article, we will be debunking 7 of the most common
                    myths about hearing aids.
                  </p>

                  <h5>“Hearing aids are only for people who are old.”</h5>
                  <p>
                    People may also think that hearing aids make one look old.
                    These are very common misconceptions regarding hearing aid
                    users since it stems from the fact that one’s hearing will
                    worsen as one ages. But it is definitely not true that
                    hearing aids are only for people who are old or make one
                    look old. Hearing loss can happen to people of any age, not
                    just people who are older. Causes of hearing loss include
                    prolonged exposure to loud noises on a regular basis (either
                    at work or during recreational activities), certain diseases
                    or infections, and even some medical treatment like
                    chemotherapy, etc. The list goes on and they can affect
                    people of any age group – not just the elderly.
                  </p>
                  <img src={imgblogfirst} className="img-fluid" />
                  <p>
                    The social stigma of how wearing hearing aids makes one look
                    old exists, but when you don’t wear hearing aids, there are
                    much more problems that will arise. This includes:
                  </p>
                  <ul>
                    <li>
                      Not being able to have engaging conversations with your
                      loved ones
                    </li>
                    <li>You can’t enjoy the activities you love</li>
                    <li>
                      Possible health issues like poorer cognitive function and
                      dementia
                    </li>
                  </ul>
                  <p>
                    Just like how one would was spectacles for their vision
                    problems, using hearing aids for one’s hearing loss issues
                    is perfectly acceptable as well and no one should shame you
                    for it.
                  </p>

                  <h5>
                    “Wearing hearing aids or not, there’s not much difference.”
                  </h5>

                  <p>
                    This myth stems from how people think that hearing aids
                    wouldn’t make a significant difference in their lives. They
                    tend to feel that even with a pair of hearing aids, the
                    activities they do will still be the same – such as talking
                    with their friends, having fun with their hobbies, work,
                    etc., so buying one is basically redundant.
                  </p>
                  <p>
                    That couldn’t be further from the truth. With hearing aids,
                    everything sounds much more complete, especially when you
                    talk to your loved ones. Their voices and laughter will
                    sound much clearer, you can have a better experience
                    interacting with them, and also feel that your time spent
                    with them is much more fulfilling.
                  </p>
                  <h5>
                    “I don’t need hearing aids since I’m used to how sounds are
                    already.”
                  </h5>

                  <p>
                    This is also another common myth among people with hearing
                    loss. Thinking that they have been living with hearing loss
                    for such a long time, they have already gotten used to how
                    everything sounds, so there’s no need for change.
                  </p>
                  <p>
                    In fact, according to the Hearing Loss Association of
                    America, people with hearing loss wait an average of 7 years
                    before seeking any help. People live so long with hearing
                    loss that they get used to it and don’t feel the need to get
                    hearing aids. But they’re simply missing out on much more
                    enjoyment in life as described earlier, that is better
                    interactions with their loved ones and a complete hearing
                    experience with their daily activities.
                  </p>
                  <h5>
                    “The cheaper hearing aids device will work well enough for
                    me.”
                  </h5>

                  <p>
                    People who have decided to get a pair of hearing aids tend
                    to feel that they just need to get one that helps them make
                    sounds louder. But cheap hearing aids often have many issues
                    such as lacking important features and most importantly
                    poorer sound quality. Users of cheaper hearing aids tend to
                    complain that the sounds don’t sound natural, and there’s a
                    lot of background noise. Instead of making their lives more
                    enjoyable, these hearing aids could introduce a whole new
                    set of inconveniences.
                  </p>

                  <p>
                    With hearing aids that are slightly more costly, sound
                    quality and background noise cancellation is significantly
                    better. Of course, your audiologist will recommend a pair
                    that is best suited to your needs but don’t fall into the
                    trap of thinking that you just need hearing aids to make
                    sounds louder and settle with the cheapest one possible.
                    Many factors come into play as well when providing you with
                    a more complete hearing experience. Investing in a slightly
                    more expensive pair is likely to be better for you in the
                    long run.
                  </p>
                  <h5>
                    “My hearing will get worse if I rely too much on hearing
                    aids.”
                  </h5>

                  <p>
                    Some people think that by relying on hearing aids, their
                    brain “forgets” what sounds are like normally. It’s a weird
                    misconception since it should be the other way around – with
                    hearing loss one will hear fewer sounds, so the brain and
                    the ear gets stimulated less and less, and perform worse
                    over time.
                  </p>

                  <p>
                    As such, it’s even more important for someone with hearing
                    loss use hearing aids and keeps their ears and brain
                    stimulated so that they don’t get worse over time.
                  </p>

                  <p>
                    If you’re a new hearing aid user, wearing your hearing aids
                    for prolonged periods of time might be exhausting. Slowly
                    get used to them by taking small breaks, and gradually
                    increase the duration of how long you wear them. Read more
                    on our 7 tips for using hearing aids for the first time.
                  </p>

                  <h5>“Hearing aids spoil very easily.”</h5>

                  <p>
                    Hearing aids only spoil easily if they are not properly
                    maintained and cleaned regularly. If done properly, most
                    hearing aids can last up to 5 years, otherwise, you would
                    have to replace them probably every 2 years or shorter and
                    spend a hefty sum of money to do so. Cleaning removes and
                    prevents the buildup of earwax on your hearing aid, but also
                    removes moisture, which can cause corrosion of the internal
                    components of the hearing aid like the speaker, microphone,
                    or battery, significantly reducing the lifespan of the
                    hearing aid. If you need guidance on cleaning and
                    maintaining your hearing aids, read up more on our tips
                    here.
                  </p>

                  <h5>“Hearing aids are too loud.”</h5>

                  <p>
                    While this might be true for hearing aids 20-30 years ago,
                    hearing aids today are much more advanced and allow the user
                    to adjust its volume without the help of an audiologist.
                  </p>
                  <p>
                    Many of such complaints also come from how background noise
                    such as the rustling of leaves and the flipping of pages
                    might sound too loud. Though sometimes the user’s sound
                    settings may be too high, it could also just be the user not
                    being used to them, since they haven’t been able to hear
                    them this clearly before using hearing aids.
                  </p>

                  <p>
                    Ultimately, if you feel that your hearing aids are too loud,
                    you just have to get it adjusted, either by yourself or with
                    the help of your audiologist. Many softer sounds that you
                    weren’t able to hear before may sound loud all of a sudden,
                    but once you get used to it, they will no longer bother you
                    as much anymore.
                  </p>

                  <h5>Conclusion</h5>
                  <p>
                    That concludes our 7 myths about hearing aids. It may be
                    difficult to get navigate through all the information
                    available on hearing aids and hearing loss and decide
                    whether or not they’re true or false. If you need more
                    information, don’t hesitate to contact us as we have
                    audiologists ready to help you.
                  </p>

                  <h5>The Hearing Centre – Best Hearing Aids in Singapore</h5>
                  <p>
                    If you are searching for the{" "}
                    <b>best hearing aids in Singapore</b>, look to{" "}
                    <b>The Hearing Centre</b>. We are a pioneer in providing the
                    top-quality hearing aids to the hearing impaired for over 17
                    years and counting. Our experienced team provides a full
                    suite of hearing-related services from consultation, to
                    assessment, hearing aid fitting, and post-care, all tailored
                    to your individual needs.
                  </p>

                  <p>
                    ith many years of strong partnership with some of the
                    leading hearing aid manufacturers in the world, we provide
                    customers with the <b>best quality hearing</b> aids at most
                    affordable prices and are proud to operate with high
                    standards of integrity.
                  </p>
                  <h5>
                    <b>Get the best hearing aids from The Hearing Centre.</b>
                  </h5>
                </div>

                <div className="COMMENTS_div" id="COMMENTS_text">
                  <h5 className="comm_text">7 COMMENTS</h5>

                  <div className="card_list_comments">
                    <div class="card COMMENTS_card">
                      <div className="card-header">
                        <img src={demoimg} class="card-img-top" alt="..." />
                        <h6>APRIL 1, 2023 3:04 AM</h6>
                      </div>
                      <div class="card-body">
                        <div>
                          <h5 class="card-title"> LIANA</h5>
                          <p class="card-text">thanks for info</p>
                        </div>
                        <a href="#form_reply" class="btn btn-primary">
                          Reply
                        </a>
                      </div>
                    </div>

                    <div class="card COMMENTS_card">
                      <div className="card-header">
                        <img src={demoimg} class="card-img-top" alt="..." />
                        <h6>APRIL 30, 2023 2:53 AM</h6>
                      </div>
                      <div class="card-body">
                        <div>
                          <h5 class="card-title"> ILMU KOMUNIKASI</h5>
                          <p class="card-text">
                            What is the purpose of the article "7 Common Myths
                            About Hearing Aids"?
                          </p>
                        </div>
                        <a href="form_reply" class="btn btn-primary">
                          Reply
                        </a>
                      </div>
                    </div>

                    <div class="card COMMENTS_card">
                      <div className="card-header">
                        <img src={demoimg} class="card-img-top" alt="..." />
                        <h6>MAY 23, 2023 8:46 PM</h6>
                      </div>
                      <div class="card-body">
                        <div>
                          <h5 class="card-title">ARCICO WELDY S</h5>
                          <p class="card-text">
                            Thank for the information, please visit
                            <a href="https://ittelkom-sby.ac.id/">
                              {" "}
                              VisitUs{" "}
                            </a>{" "}
                          </p>
                        </div>
                        <a href="#" class="btn btn-primary">
                          Reply
                        </a>
                      </div>
                    </div>

                    <div class="card COMMENTS_card">
                      <div className="card-header">
                        <img src={demoimg} class="card-img-top" alt="..." />
                        <h6>JUNE 1, 2023 9:21 AM</h6>
                      </div>
                      <div class="card-body">
                        <div>
                          <h5 class="card-title">LOKASI UMJ</h5>
                          <p class="card-text">
                            I am very interested in the information contained in
                            this post. The information contained in this post
                            inspired me to generate research ideas.
                            <a href="https://umj.ac.id ">Lokasi UMJ</a>
                          </p>
                        </div>
                        <a href="#" class="btn btn-primary">
                          Reply
                        </a>
                      </div>
                    </div>

                    <div class="card COMMENTS_card">
                      <div className="card-header">
                        <img src={demoimg} class="card-img-top" alt="..." />
                        <h6>APRIL 1, 2023 3:04 AM</h6>
                      </div>
                      <div class="card-body">
                        <div>
                          <h5 class="card-title"> KAMPUS TERBAIK</h5>
                          <p class="card-text">
                            nice info thankyou cant wait to see ur another info{" "}
                            <a href="https://umj.ac.id ">Kampus Terbaik</a>
                          </p>
                        </div>
                        <a href="#" class="btn btn-primary">
                          Reply
                        </a>
                      </div>
                    </div>
                  </div>

                  <h5 className="comm_text">Leave a reply</h5>
                  <form id="form_reply">
                    <div class="mb-3">
                      <label for="YOURNAME" class="form-label">
                        YOUR NAME
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="YOUR NAME"
                        placeholder="YOUR NAME"
                      />
                    </div>

                    <div class="mb-3">
                      <label for="YOUREMAIL" class="form-label">
                        YOUR EMAIL
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="YOUREMAIL"
                        placeholder="YOUREMAIL"
                      />
                    </div>

                    <div class="mb-3">
                      <label for="website" class="form-label">
                        WEBSITE (optional)
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="website"
                        placeholder="WEBSITE (optional)                        "
                      />
                    </div>
                    <div class="mb-3">
                      <label for="YOURCOMMENT" class="form-label">
                        YOUR COMMENT
                      </label>
                      <textarea
                        class="form-control"
                        id="YOURCOMMENT"
                        rows="6"
                      ></textarea>
                    </div>
                    <button className="btn">POST COMMENT</button>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="Categories_section">
                <h1>Categories</h1>
                <div className="Categories_list">
                  <Link to="">General</Link>
                  <Link to="">Hearing Aids</Link>
                  <Link to="">Uncategorized</Link>
                </div>

                <h1>Most Commented</h1>
                <div className="Most_comment">
                  <h5>
                    7 Common Myths About Hearing Aids <span>7</span>
                  </h5>
                  <p>JUNE 23, 2022</p>
                </div>

                <div className="Most_comment">
                  <h5>
                    The Must-Knows of Hearing Loss <span>4</span>
                  </h5>
                  <p>February 12, 2017</p>
                </div>

                <div className="Most_comment">
                  <h5>
                    Hearing Aid: How To Choose The Right One <span>3</span>
                  </h5>
                  <p>March 18, 2021</p>
                </div>
                <div className="Most_view">
                  <h1>Most Viewed</h1>
                  <div className="Most_comment">
                    <h5>
                      7 Common Myths About Hearing Aids <span>7</span>
                    </h5>
                    <p>JUNE 23, 2022</p>
                  </div>

                  <div className="Most_comment">
                    <h5>
                      The Must-Knows of Hearing Loss <span>4</span>
                    </h5>
                    <p>February 12, 2017</p>
                  </div>

                  <div className="Most_comment">
                    <h5>
                      Hearing Aid: How To Choose The Right One <span>3</span>
                    </h5>
                    <p>March 18, 2021</p>
                  </div>
                </div>

                <h1>Tags</h1>
                <div className="Categories_list Tags">
                  <Link to="">cochlear implant</Link>
                  <Link to="">covid 19 and hearing loss</Link>
                  <Link to="">Hearing</Link>
                  <Link to="">hearing aid</Link>
                  <Link to="">hearing aids</Link>

                  <Link to="">Hearingaids</Link>
                  <Link to="">hearing aid singapore</Link>
                  <Link to="">hearing aids singapore</Link>
                  <Link to="">hearing centre</Link>
                  <Link to="">hearing centre singapore</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
